import { createFileRoute, Outlet } from '@tanstack/react-router'
import { accountQuery, useIsAdmin } from 'hooks/auth'
import { Account } from 'types/auth'

export const Route = createFileRoute('/_auth/_admin')({
  beforeLoad: async ({ context: { queryClient } }) => {
    return queryClient.ensureQueryData<Account>(accountQuery)
  },
  component: AdminAuthLayout,
})

function AdminAuthLayout() {
  const isAdmin = useIsAdmin()

  if (isAdmin) {
    return <Outlet />
  } else {
    return <div>Tylko administrator ma dostęp do tej strony.</div>
  }
}
